import React from 'react';
import { Form } from 'react-bootstrap';
import { getCategoryTypeOptions } from '../constants/categoryTypes';

const CategoryTypeSelect = ({ 
  name = 'type',
  value, 
  onChange, 
  className = '',
  showAllOption = false,
  allOptionText = 'Todos os tipos',
  placeholder = 'Selecione...',
  required = false,
  'data-testid': dataTestId,
  ...props 
}) => {
  const options = getCategoryTypeOptions();

  return (
    <Form.Select
      name={name}
      value={value}
      onChange={onChange}
      className={className}
      required={required}
      data-testid={dataTestId}
      {...props}
    >
      {!required && (
        <option value="">
          {showAllOption ? allOptionText : placeholder}
        </option>
      )}
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Form.Select>
  );
};

export default CategoryTypeSelect; 